//import { BASIC_INITIAL_STATE } from '../../utils/HttpHelper';

import GetSecurityInfoForToken from './GetSecurityInfoForToken';
import getRoutesForContext from './GetRoutesForContext';
import { clearUserInfoCache } from '../../utils/UserInfoCache';

const BASIC_INITIAL_STATE = {
  isArrayLoading: false,
  isArrayLoaded: false,
  isObjLoading: false,
  isObjLoaded: false,
  isSaving: false,
  isSaved: false,
  arrayData: [],
  objData: {},
  message: ''
};

const SECURITY_INITIAL_STATE = {
  isObjLoading: false,
  isObjLoaded: false,
  userInfo: {},
  message: '',
  retries: 0
};

const CONTEXT_SECURITY_INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  showNav: false,
  contextId: '',
  scope: '',
  taxonomies: [],
};

const NAV_ROUTES_INITIAL_STATE = {
  isReadyToRoute: false,
  navRoutes: {}
};

const login = () => {
  const authUrl = `${import.meta.env.VITE_YARP_BASE_URL}/bff/login?returnUrl=` + encodeURIComponent(window.location.origin + window.location.pathname + window.location.search );
  window.location.href = authUrl;
};

const logout = (retUrl) => {
  clearUserInfoCache();
  const authUrl = `${import.meta.env.VITE_YARP_BASE_URL}/bff/logout?returnUrl=` + encodeURIComponent(`${import.meta.env.VITE_YARP_BASE_URL}/landing`);
  window.location.href = authUrl;
  return;
};

const logoutWithMemberIdParam = (childMemberId) => {
  clearUserInfoCache();
  const ipLogoutUrl = import.meta.env.VITE_LOGOUT_URL;
  const postLogoutRedirectUri = `${window.location.protocol}//${import.meta.env.VITE_BASE_DOMAIN}`;
  const postLogoutRedirectUriWithMemberIdParam = `${window.location.protocol}//${import.meta.env.VITE_BASE_DOMAIN}/landing?memberId=${childMemberId}`;
  const href = `${ipLogoutUrl}?post_logout_redirect_uri=${encodeURIComponent(postLogoutRedirectUri)}`;
  window.location.href = href;
  window.location.href = postLogoutRedirectUriWithMemberIdParam;
  return;
};

const logoutWithParams = (paramsObj) => {
  clearUserInfoCache();
  const ipLogoutUrl = import.meta.env.VITE_LOGOUT_URL;
  const postLogoutRedirectUri = `${window.location.protocol}//${import.meta.env.VITE_BASE_DOMAIN}`;
  let paramsForUrl = '';

  for (const [key, value] of Object.entries(paramsObj)) {
    if (paramsForUrl === '') {
      paramsForUrl = `?${key}=${value}`
    } else {
      paramsForUrl += `&${key}=${value}`
    }
  }

  const postLogoutRedirectUriWithParams = `${window.location.protocol}//${import.meta.env.VITE_BASE_DOMAIN}/landing${paramsForUrl}`;
  const href = `${ipLogoutUrl}?post_logout_redirect_uri=${encodeURIComponent(postLogoutRedirectUri)}`;
  window.location.href = href;
  window.location.href = postLogoutRedirectUriWithParams;
  return;
};

const SecurityData = {
  SECURITY_INITIAL_STATE,
  CONTEXT_SECURITY_INITIAL_STATE,
  NAV_ROUTES_INITIAL_STATE,
  login,
  logout,
  logoutWithMemberIdParam,
  logoutWithParams,
  GetSecurityInfoForToken,
  getRoutesForContext
};

export default SecurityData;